import { Routes } from '@angular/router';

import { ClientConfigProductName, routeData } from '@frontend/vanilla/core';

import { HomeLobbyModComponent } from './home-lobby-mod';
import { CasinoHomePageGuard } from './home-lobby-mod/casino-home-page.gaurd';
import { PublicPagesGuard } from './publicPagesWrapper/publicPages.guard';

export const CASINO_INTERNAL_ROUTES: Routes = [
    {
        path: '',
        component: HomeLobbyModComponent,
        canActivate: [CasinoHomePageGuard],
        data: {
            ...routeData({ allowAnonymous: true }),
            product: 'host',
            segment: 'main',
        },
    },
    {
        path: 'gamelogs',
        loadComponent: () => import('./game-logs-ctrl/game-logs-ctrl.component').then((mod) => mod.GameLogsCtrlComponent),
    },
    {
        path: 'p',
        loadChildren: () => import('@frontend/vanilla/features/public-page').then((mod) => mod.ROUTES),
        data: {
            waitForPageViewData: true,
            publicPageRoot: 'MobilePortal-v1.0/PublicPages/',
            product: ClientConfigProductName.CASINO,
        },
    },
    {
        path: 'p',
        children: [
            {
                path: '**',
                loadComponent: () => import('./publicPagesWrapper/publicPagesWrapper.component').then((mod) => mod.PublicPagesWrapperComponent),
                data: {
                    publicPageRoot: 'MobileCasino-v1.0/PublicPages/',
                },
                canActivate: [PublicPagesGuard],
            },
        ],
    },
    {
        path: 'foxy-den',
        loadChildren: () => import('./common-routes/foxy-den.routes').then((mod) => mod.foxyDenRoutes),
    },
    {
        path: 'foxy-space',
        loadChildren: () => import('./common-routes/foxy-space.routes').then((mod) => mod.foxySpaceRoutes),
    },

    {
        path: 'comppoints',
        loadChildren: () => import('./common-routes/comp-points.routes').then((mod) => mod.compointsRoutes),
    },
    {
        path: 'launchng/:gameId',
        loadComponent: () => import('./sections/play-redirect/play-redirect.component').then((mod) => mod.PlayRedirectComponent),
        data: routeData({ authorized: true }),
    },
    {
        path: 'g/:globaljackpotpath',
        loadComponent: () =>
            import('./mod-casino/global-jackpot/global-jackpots-page/global-jackpots-page.component').then((mod) => mod.GlobalJackpotPageComponent),
    },
    {
        path: 'c/:categoryType',
        loadComponent: () => import('./home-lobby-mod/home-lobby-mod.component').then((m) => m.HomeLobbyModComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'casinowidget/:categoryType',
        loadComponent: () => import('./home-lobby-mod/home-lobby-mod.component').then((m) => m.HomeLobbyModComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'game-info/:gameId',
        loadComponent: () => import('./home-lobby-mod/home-lobby-mod.component').then((m) => m.HomeLobbyModComponent),
        canActivate: [CasinoHomePageGuard],
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: 'c/:categoryType/game-info/:gameId',
        loadComponent: () => import('./home-lobby-mod/home-lobby-mod.component').then((m) => m.HomeLobbyModComponent),
    },
    {
        path: 'myfreespins/history',
        loadChildren: () => import('./sections/freespins/my-freespins/my-freespins-routing').then((mod) => mod.myFreespinsRoutes),
    },
];
